import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const I18N_CONTEXT_SYMBOL = Symbol();
const useI18n = ()=>useImmutableContext(I18N_CONTEXT_SYMBOL);
const useI18nProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(I18N_CONTEXT_SYMBOL, ...args);
};
export { useI18n, useI18nProvider };
